import {
  apiDeleteFloatingConcept,
  apiDeleteFloatingConceptsMassive,
  apiGetBalanceActionsFloatingConcepts,
  apiGetFloatingConcepts,
  apiGetFloatingConceptsByContractID,
  apiGetFloatingConceptsBySettlementGroupID,
  apiGetRightsFloatingConcepts,
  apiGetRightsFloatingConceptsByContractID,
  apiGetVirtualBatteryBalance,
  apiGetVirtualBatteryBalanceDetail,
  apiPatchFloatingConcept,
  apiPostFloatingConcept
} from '../../api/Argentia/endpoints/floatingConcepts/floatingConcepts.api'
import {
  FloatingConceptsDataTableModel,
  FloatingConceptsModel,
  FloatingConceptsModelPostRequest,
  VirtualBatteryBalanceDetailModel,
  VirtualBatteryBalanceModel
} from '../../api/Argentia/endpoints/floatingConcepts/model/floatingConcepts'
import { EnumCommodity } from '../../api/Argentia/enums'
import { EnumTipoConceptoFlotante } from '../../api/oData/enums/enumTipoConceptoFlotante'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import i18n from '../../i18n'
import { ActionIcons, DataTableActionConfiguration } from '../../model'
import { ServiceResponse } from '../../model/serviceResponse'
import FloatingConceptsListItemViewModel from './floatingConcepts.model'

// export const postFloatingConceptItem = async (
//   floatingConcept: any
// ): Promise<ServiceResponse<any>> => {
//   return await apiFloatingConceptsPost(floatingConceptsMapperToAPI_POST(floatingConcept))
//     .then(response => {
//       return createSuccessServiceResponse(response)
//     })
//     .catch(error => {
//       return createErrorServiceResponse(error)
//     })
// }

export const createFloatingConcept = async (
  floatingConcept: FloatingConceptsModelPostRequest
): Promise<ServiceResponse<any>> => {
  return await apiPostFloatingConcept(floatingConcept)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

// export const patchFloatingConceptItem = async (
//   floatingConcept: any
// ): Promise<ServiceResponse<any>> => {
//   return await apiFloatingConceptsPatch(floatingConceptsMapperToAPI_PATCH(floatingConcept))
//     .then(response => {
//       return createSuccessServiceResponse(response)
//     })
//     .catch(error => {
//       return createErrorServiceResponse(error)
//     })
// }

export const patchFloatingConcept = async (
  floatingConcept: Partial<FloatingConceptsModelPostRequest>
): Promise<ServiceResponse<any>> => {
  return await apiPatchFloatingConcept(floatingConcept)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteFloatingConcept = async (floatingConceptId: number) => {
  return await apiDeleteFloatingConcept(floatingConceptId)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteFloatingConceptsMassive = async (floatingConceptIds: number[]) => {
  return await apiDeleteFloatingConceptsMassive(floatingConceptIds)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

// export const deleteFloatingConceptsItems = (floatingConcept: any): Promise<boolean> => {
//   return apiFloatingConceptsDelete(floatingConceptsMapperToAPI_DELETE(floatingConcept))
//     .then(() => {
//       return true
//     })
//     .catch(() => {
//       return false
//     })
// }

export const filterApplicableActionsConfiguration = (
  item: FloatingConceptsListItemViewModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.WARNING: {
        break
      }
      case ActionIcons.ERROR: {
        break
      }
    }
  })

  return applicableActionsConfiguration
}

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getQuantityDisagreementAction(), getStateDisagreementAction()]
}

const getQuantityDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.WARNING,
    tooltip: i18n.t('translation:pages.allocations.dataTable.tooltips.quantityDisagreement')
  }
}

const getStateDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.ERROR,
    tooltip: i18n.t('translation:pages.allocations.dataTable.tooltips.stateDisagreement')
  }
}

export const fetchVirtualBatteryBalance = async (): Promise<
  ServiceResponse<VirtualBatteryBalanceModel[] | undefined>
> => {
  return await apiGetVirtualBatteryBalance()
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchVirtualBatteryBalanceDetailList = async (
  contractID: number,
  settlementGroupID: number
): Promise<ServiceResponse<VirtualBatteryBalanceDetailModel[] | undefined>> => {
  return await apiGetVirtualBatteryBalanceDetail(contractID, settlementGroupID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchFloatingConceptsByContractID = async (
  contractID: number,
  commodity: EnumCommodity,
  tipoConcepto: EnumTipoConceptoFlotante,
  startDate?: string,
  endDate?: string
): Promise<ServiceResponse<FloatingConceptsDataTableModel[] | undefined>> => {
  return await apiGetFloatingConceptsByContractID(
    contractID,
    commodity,
    tipoConcepto,
    startDate,
    endDate
  )
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchRightsFloatingConceptsByContractID = async (
  contractID: number,
  startDate?: string,
  endDate?: string
): Promise<ServiceResponse<FloatingConceptsDataTableModel[] | undefined>> => {
  return await apiGetRightsFloatingConceptsByContractID(contractID, startDate, endDate)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchFloatingConceptsBySettlementGroupID = async (
  settlementGroupID: number,
  startDate?: string,
  endDate?: string
): Promise<ServiceResponse<FloatingConceptsDataTableModel[] | undefined>> => {
  return await apiGetFloatingConceptsBySettlementGroupID(settlementGroupID, startDate, endDate)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchFloatingConcepts = async (
  commodity: EnumCommodity,
  tipoConcepto: EnumTipoConceptoFlotante
): Promise<ServiceResponse<FloatingConceptsDataTableModel[] | undefined>> => {
  return await apiGetFloatingConcepts(commodity, tipoConcepto)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchRightsFloatingConcepts = async (): Promise<
  ServiceResponse<FloatingConceptsDataTableModel[] | undefined>
> => {
  return await apiGetRightsFloatingConcepts()
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchBalanceActionsFloatingConcepts = async (): Promise<
  ServiceResponse<FloatingConceptsDataTableModel[] | undefined>
> => {
  return await apiGetBalanceActionsFloatingConcepts()
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
